import {ClientProviderPreference, Offer, Referral} from "../../domains";
import {PAGE} from "../../const";
import {Dictionary} from "lodash";
import {ProviderOfferDetailGridViewColumn} from "./ProviderOfferDetailGridViewColumn";
import {UnmatchReturnOfferModalState} from "../ProviderOfferReturnedModal";

type providerOfferDetailGridView = {
    rootGuid: string;
    offersByReferralGuid: Dictionary<Offer[]>;
    referralsGroupByGuid: Dictionary<Referral[]>;
    selectedItem: Offer | null;
    setSelectedItem: (offer: Offer | null) => void;
    setUnmatchReturnModalState: (show: UnmatchReturnOfferModalState) => void;
    prefsSibling: ClientProviderPreference[];
    recentPage: PAGE;
};

export function ProviderOfferDetailGridView({
                                                offersByReferralGuid,
                                                selectedItem,
                                                setSelectedItem,
                                                recentPage,
                                                setUnmatchReturnModalState,
                                                referralsGroupByGuid,
                                                prefsSibling,
                                                rootGuid
                                            }: providerOfferDetailGridView) {
    const gridViewSort = Object.entries(offersByReferralGuid)
        .sort(([referralGuid1, _], [referralGuid2, __]) => {
            return referralGuid1 === rootGuid ? -1 : referralGuid2 === rootGuid ? 1 : 0
        });

    return (
        <div className='flex flex-grow scrollbar-always'>
            {
                gridViewSort.map(([referralGuid, listOffer]) =>
                    <ProviderOfferDetailGridViewColumn offers={listOffer}
                                                       key={referralGuid}
                                                       referral={referralsGroupByGuid[referralGuid][0]}
                                                       selectedItem={selectedItem}
                                                       setSelectedItem={setSelectedItem}
                                                       setUnmatchReturnModalState={setUnmatchReturnModalState}
                                                       prefsSibling={prefsSibling}
                                                       recentPage={recentPage}/>)
            }
        </div>);
}

